export default __webpack_public_path__ + "c3d0f994945ba3a5839dfd6d41e3be76.png";